"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Label = _interopRequireDefault(require("./Label.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Label = function Label(_ref) {
  var id = _ref.id,
    children = _ref.children,
    className = _ref.className,
    htmlFor = _ref.htmlFor,
    required = _ref.required,
    isDisabled = _ref.isDisabled;
  return /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    id: id,
    className: className,
    isDisabled: isDisabled,
    htmlFor: htmlFor,
    required: required
  }, children, required ? ' *' : '');
};
Label.propTypes = {
  id: _propTypes["default"].string,
  /**
   * The contents of the `Label`.
   */
  children: _propTypes["default"].node,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * @ignore
   */
  htmlFor: _propTypes["default"].string,
  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: _propTypes["default"].bool,
  /**
   * if disabled we will gray it out
   */
  isDisabled: _propTypes["default"].bool
};
Label.defaultProps = {
  id: '',
  className: '',
  htmlFor: '',
  required: false,
  isDisabled: false,
  children: null
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Label);